<template>
  <section class="section">
    <div class="container">
      <div class="row align-items-center">
        <!-- 左側: テキスト -->
        <div class="col-md-6 shop-text fade-in-up">
          <h2 class="shop-title">
            あの『ほっかほっか大将』が<br>大学に届く。
          </h2>
          <p class="shop-name">おけらとじゅんじの店</p>
          <div class="price-badges">
            <span class="price-badge">600円〜</span>
            <span class="price-badge price-badge--accent">ジャイアン 1560円</span>
          </div>
        </div>
        <!-- 右側: 弁当画像カード -->
        <div class="col-md-6 fade-in-up delay-2">
          <div class="bento-card">
            <img src="/img/top/gian.webp" alt="ジャイアン弁当" class="bento-img">
            <div class="bento-info">
              <p class="bento-name">
                ジャイアン（ピリ辛もやし・めんたい・マヨネーズ・からあげいっぱい・ちくわ2本）
              </p>
              <p class="bento-price">&yen;1560</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SectionShop',
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables';
@import '@/assets/scss/mixins';

.shop-title {
  font-size: $font-size-section-title;
  font-weight: 700;
  color: $color-text;
  line-height: 1.4;
  margin-bottom: 1rem;

  @include media-down(768px) {
    font-size: 1.5rem;
    text-align: center;
  }
}

.shop-name {
  font-size: $font-size-section-subtitle;
  color: $color-text-light;
  margin-bottom: 1.5rem;

  @include media-down(768px) {
    text-align: center;
  }
}

.price-badges {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;

  @include media-down(768px) {
    justify-content: center;
  }
}

.price-badge {
  background-color: $color-primary;
  color: #fff;
  padding: 0.4rem 1.25rem;
  border-radius: 50px;
  font-size: $font-size-small;
  font-weight: 600;
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-2px);
  }

  // アクセントバリエーション
  &--accent {
    background-color: $color-sub;
  }
}

.bento-card {
  background-color: #fff;
  border-radius: $border-radius-lg;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  }

  @include media-down(768px) {
    margin-top: 2rem;
  }
}

.bento-img {
  width: 100%;
  height: 280px;
  object-fit: cover;
  object-position: center;
}

.bento-info {
  padding: 1.25rem 1.5rem;
}

.bento-name {
  font-size: $font-size-body;
  color: $color-text;
  font-weight: 600;
  margin-bottom: 0.5rem;
  line-height: 1.6;
}

.bento-price {
  font-size: $font-size-section-subtitle;
  color: $color-primary;
  font-weight: 700;
  margin-bottom: 0;
}
</style>
